import styled from "styled-components";
import { Colors } from "../../shared/colors/colors";

export const ContainerButtons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;
export const ReajusteValoresFinanceirosContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  padding: 0;
  border-radius: 0;
  border: 0;
`;
export const LoadingGif = styled.img`
  width: 100px;
  height: 100px;
`;

export const TextAreaObservacao = styled.textarea`
  resize: vertical;
  min-height: 118px;
  width: 100%;
  border: 1px solid ${Colors.borderInput};
  border-radius: 8px;
  padding: 12px;
  font-family: inherit;
  font-size: 16px;
  outline: none;
  &:disabled {
    background-color: #f5f6f7;
    cursor: not-allowed;
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 32px 60px;
  gap: 16px;
  width: 90vw;
`;

export const TitleAndButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;


export const EmptySearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  text-align: center;
  background-color: ${Colors.backgroundColorTable};
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin: 20px 0;
`;

export const EmptySearchMessage = styled.h4`
  color: ${Colors.primary};
  font-size: 1.2rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

